import {
    GETKYCLABELPARTNER_SUCCESS,
    GETKYCLABELPARTNER_FAILED,
    RESET_GETKYCLABELPARTNER,
    LOADING_GETKYCLABELPARTNER,
    NETWORK_ERROR_GETKYCLABELPARTNER,
} from "../types/index";
import { partnerServices } from "../../config/axios";

const resetGetKycLabel = () => {
    return { type: RESET_GETKYCLABELPARTNER };
};

const getKycLabelLists = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_GETKYCLABELPARTNER });
    await partnerServices
        .post("getkycLabel", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch(getKycLabelsuccess(res.data));
                    break;
                default:
                    dispatch(getKycLabelFailed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({ type: NETWORK_ERROR_GETKYCLABELPARTNER, payload: err });
        });
};
function getKycLabelsuccess(data) {
    return {
        type: GETKYCLABELPARTNER_SUCCESS,
        payload: data,
    };
}
function getKycLabelFailed(data) {
    return {
        type: GETKYCLABELPARTNER_FAILED,
        payload: data,
    };
}

export { resetGetKycLabel, getKycLabelLists };